import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import P2pLayout from './P2pLayout';
import './p2p.css';

const P2pTradeOrder = () => {
  const [selectedPayment, setSelectedPayment] = useState('Bank Transfer');
  const [chatMessage, setChatMessage] = useState('');
  const navigate = useNavigate();

  return (
    <P2pLayout title="Order Details">
      <div className="p2p-order-details-container">
        {/* TOP HEADER */}
        <div className="p2p-od-header-row">
          <div className="p2p-od-header-left">
            <h2>Buy USDT</h2>
            <p>Complete your payment within the time limit.</p>
            <div className="p2p-od-escrow-badge">
              <i className="ri-lock-fill"></i> AGCX holds your funds securely in escrow
            </div>
          </div>
          <div className="p2p-od-header-right">
            <div className="p2p-od-timer-box">
              <span className="p2p-od-box-label">Payment Time Remaining</span>
              <div className="p2p-od-timer-val">
                <strong>14</strong><span>:</span><strong>59</strong> <small>MIN</small> <small>SEC</small>
              </div>
            </div>
            <div className="p2p-od-info-box">
              <div className="p2p-od-info-col">
                <span className="p2p-od-box-label">Order ID</span>
                <strong>AGC19851202856 <i className="ri-file-copy-line"></i></strong>
              </div>
              <div className="p2p-od-info-col">
                <span className="p2p-od-box-label">Created On</span>
                <strong>28 Sep 2023, 12:52 PM</strong>
              </div>
            </div>
          </div>
        </div>

        {/* STEPPER */}
        <div className="p2p-od-stepper-container">
          <div className="p2p-od-step active">
            <div className="p2p-od-step-circle">1</div>
            <div className="p2p-od-step-text">
              <h4>Confirm Order</h4>
              <p>Review order & payment details</p>
            </div>
          </div>
          <div className="p2p-od-step-line"></div>
          <div className="p2p-od-step current">
            <div className="p2p-od-step-text-only">2</div>
            <div className="p2p-od-step-text">
              <h4>Make Payment</h4>
              <p>Transfer to seller account</p>
            </div>
          </div>
          <div className="p2p-od-step-line dashed"></div>
          <div className="p2p-od-step pending">
            <div className="p2p-od-step-text-only">3</div>
            <div className="p2p-od-step-text">
              <h4>Payment Confirmation</h4>
              <p>Seller releases crypto</p>
            </div>
          </div>
        </div>

        {/* MAIN BODY */}
        <div className="p2p-od-main-body">
          {/* LEFT COLUMN */}
          <div className="p2p-od-left-col">

            {/* Order Details Card */}
            <div className="p2p-od-card p2p-od-details-card">
              <div className='header_card_top'>
                <h3>Order Details</h3>
              </div>
              <div className="p2p-od-details-grid">
                <div className="p2p-od-detail-item">
                  <strong>₹ 10,000</strong>
                  <span>Amount</span>
                </div>
                <div className="p2p-od-detail-item">
                  <strong>₹ 100.85</strong>
                  <span>Price (1 USDT)</span>
                </div>
                <div className="p2p-od-detail-item">
                  <strong>99.30 USDT</strong>
                  <span>Quantity</span>
                </div>
                <div className="p2p-od-detail-item">
                  <strong>P2P Order</strong>
                  <span className="p2p-od-buy-tag">Buy USDT</span>
                </div>
              </div>
            </div>

            {/* Payment Method Card */}
            <div className="p2p-od-card p2p-od-payment-card">
              <div className='header_card_top'>
                <h3>Payment Method</h3>
                <p className="p2p-od-payment-desc">
                  Please transfer the exact amount to the seller using the details below.<br />
                  Money not transferred from your verified account or exact amount may cause order cancellation.
                </p>
              </div>

              <div className='payment_method_bl'>

                <div className="p2p-od-warning-note">
                  <div className="p2p-od-warning-icon"><i className="ri-error-warning-fill"></i></div>
                  <div>Important: Use only your own bank account. Money will not be transferred automatically by the platform.</div>
                </div>

                <div className="p2p-od-payment-split">
                  <div className="p2p-od-payment-options">
                    {['Bank Transfer', 'UPI', 'IMPS', 'Net Banking'].map((method) => (
                      <label key={method} className={`p2p-od-radio-label ${selectedPayment === method ? 'active' : ''}`}>
                        <input
                          type="radio"
                          name="paymentMethod"
                          checked={selectedPayment === method}
                          onChange={() => setSelectedPayment(method)}
                        />
                        {method === 'Bank Transfer' ? <i className="ri-bank-line"></i> : <div className="radio-custom"></div>}
                        {method}
                      </label>
                    ))}
                  </div>
                  <div className="p2p-od-payment-details">
                    <div className="p2p-od-pay-row">
                      <span>Bank Name</span>
                      <strong>Bank of Baroda</strong>
                    </div>
                    <div className="p2p-od-pay-row">
                      <span>Account Number</span>
                      <strong>8562 8296 8562 8762 <i className="ri-file-copy-line"></i></strong>
                    </div>
                    <div className="p2p-od-pay-row">
                      <span>Account Holder Name</span>
                      <strong>John Wick Kapoor <i className="ri-file-copy-line"></i></strong>
                    </div>
                    <div className="p2p-od-pay-row">
                      <span>IFSC Code</span>
                      <strong>BARB0XXXXXX <i className="ri-file-copy-line"></i></strong>
                    </div>
                    <div className="p2p-od-pay-row">
                      <span>Branch</span>
                      <strong>Jaipur, Rajasthan</strong>
                    </div>
                    <div className="p2p-od-pay-row">
                      <span>Account Type</span>
                      <strong>Savings Account</strong>
                    </div>
                  </div>
                </div>

              </div>

            </div>

            {/* Next Step */}
            <div className="p2p-od-next-step">
              <h3>Next Step</h3>
              <p>Once you have made the payment, click the button below.</p>
              <p>The seller will be notified and will release the USDT to your account.</p>
              <div className="p2p-od-action-btns">
                <button className="p2p-od-paid-btn">I Have Paid, Notify Seller</button>
                <button className="p2p-od-cancel-btn" onClick={() => navigate('/p2p-dashboard')}>Cancel Order</button>
              </div>
            </div>

          </div>

          {/* RIGHT COLUMN - CHAT */}
          <div className="p2p-od-right-col">
            <div className="p2p-od-chat-card">
              <div className="p2p-od-chat-header">

                <div className='p2ptop_right'>

                  <div className="p2p-od-chat-user">
                    <div className="p2p-od-chat-avatar">T</div>
                    <div className="p2p-od-chat-info">
                      <h4>Trunks097 <i className="ri-verified-badge-fill"></i></h4>
                      <div className="p2p-od-chat-rating">
                        <div className="stars">
                          <i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i>
                        </div>
                        <span>5.0</span>
                      </div>
                    </div>
                  </div>
                  <div className="p2p-od-chat-stats">
                    <div>
                      <span>Orders</span>
                      <strong>356</strong>
                    </div>
                    <div>
                      <span>Completion Rate</span>
                      <strong>99.40%</strong>
                    </div>
                  </div>
                </div>

                <div className="p2p-od-chat-badges">
                  <span>KYC Verified</span>
                  <span>Email Verified</span>
                  <span>Phone Verified</span>
                </div>
              </div>

              <div className="p2p-od-chat-body">
                <div className="p2p-od-msg-row received">
                  <div className="p2p-od-msg-avatar">T</div>
                  <div className="p2p-od-msg-bubble">
                    <p>Hi, please complete the payment within the time limit.</p>
                    <span className="p2p-od-msg-time">12:52 PM</span>
                  </div>
                </div>

                <div className="p2p-od-msg-row system">
                  <div className="p2p-od-msg-bubble system-msg">
                    <p>AGCX will never ask you to release crypto or cancel the order. Do not share your personal information with anyone.</p>
                  </div>
                </div>

                <div className="p2p-od-msg-row received">
                  <div className="p2p-od-msg-avatar">T</div>
                  <div className="p2p-od-msg-bubble">
                    <p>Please share the payment screenshot once the transfer is complete. I will verify and release the crypto promptly.</p>
                    <span className="p2p-od-msg-time">12:53 PM</span>
                  </div>
                </div>

                <div className="p2p-od-msg-row sent">
                  <div className="p2p-od-msg-bubble">
                    <p>Payment done. Please check and release the crypto.</p>
                    <span className="p2p-od-msg-time">12:54 PM <i className="ri-check-double-line"></i></span>
                  </div>
                  <div className="p2p-od-msg-avatar me">M</div>
                </div>
              </div>

              <div className="p2p-od-chat-footer">
                <input
                  type="text"
                  placeholder="Type your message..."
                  value={chatMessage}
                  onChange={(e) => setChatMessage(e.target.value)}
                />
                <button className="p2p-od-chat-attach"><i className="ri-emotion-line"></i></button>
                <button className="p2p-od-chat-send"><i className="ri-send-plane-fill"></i></button>
              </div>
            </div>
          </div>

        </div>

        {/* Description */}
        <div className="p2p-od-card p2p-od-desc-card">
          <div className="p2p-od-desc-content">
            <h3>Description</h3>
            <ul>
              <li>Only complete payments using the payment methods shown for this order.</li>
              <li>Do not release crypto until you have confirmed that payment has been received.</li>
              <li>Never share your password, OTP, or 2FA codes with anyone, including counterparty traders.</li>
              <li>Use AGCX chat for all order communication so your trade remains protected by escrow.</li>
            </ul>
          </div>
          <div className="p2p-od-desc-image">
            <img src="/images/p2p/p2p_security_vector.png" alt="Security Shield" />
          </div>
        </div>

      </div>
    </P2pLayout>
  );
};

export default P2pTradeOrder;
